@if (hasPermissionToMainDashboard$ | async) {
    <medpace-table
        data-testid="active-studies-component-table"
        (rowClickEvent)="doClickRow($event)"
        [columns]="otherStudiesColumns"
        [data]="(mainActiveStudies$ | async) || undefined"
        [fieldMap]="otherStudiesColumnMap"
        [isSearching]="true"
        title="Active Studies"
        [defaultSorting]="{ columnName: 'sponsor', direction: 'asc' }"
    ></medpace-table>
}

@if (hasPermissionToCrcDashboard$ | async) {
    <medpace-table
        data-testid="active-studies-crc-component-table"
        [data]="(crcActiveStudies$ | async) || undefined"
        title="Active Studies"
        [columns]="crcColumns"
        [fieldMap]="crcColumnMap"
        [ifFiltering]="false"
        [isSearching]="true"
        (rowClickEvent)="doClickRow($event)"
        [defaultSorting]="{ columnName: 'sponsor', direction: 'asc' }"
    ></medpace-table>
}
